import { Injectable } from '@angular/core';

@Injectable()
export class Favorites {
    favorites: object[]

    constructor() {
        this.favorites = []
    }
    addToFavorites(data): void {
        this.favorites.push(data)
       
    }
    getFavorites() {
        return this.favorites
    }
   

}